<template>
    <nav>
        <div class="logo-container">
            <div @click="redirectToHome()" title="Accueil" class="">
                <img v-if="siteInfos.ImageLogo !== undefined" :src="apiUrl+'/'+siteInfos.ImageLogo" alt="Logo"
                     class="">
            </div>
            <div>
                <span v-if="detailTitle && !isRecap" class="ccm-trigger"
                      @click="fillAndOpenDefaultModal()">{{detailTitle}}</span>
            </div>
        </div>
        <div class="header-title-container">
            <div class="top-info d-none d-lg-flex">
                <h2 class="header-title">
                    <span class="header-title-brand">{{siteInfos.BaselineTop}}</span>

                </h2>

                <div class="header-tel-container">
                    <a :href="'tel:' + siteInfos.Telephone">
                        <i class="fa fa-phone-square"></i>
                        {{siteInfos.Telephone}}
                    </a>
                </div>

                <div class="cart-btn" v-if="shouldDisplayCartBtn" @click="toggleCartConfirm()">
                    <span class="header-title-brand btn back-btn bold">Voir mes produits</span>
                </div>

                <div class="cart-btn" v-if="shouldDisplayCartBtnPreConf" @click="redirectToRecap()">
                    <span class="header-title-brand btn back-btn bold">Voir mes produits</span>
                </div>
            </div>
            <div class="top-info d-lg-none">
                <h2 class="header-title">
                    <span class="header-title-brand">CONCEVEZ VOTRE PROJET SUR-MESURE</span>
                </h2>
                <div class="mobile-nav-bloc">
                    <div class="cart-btn-mobile" v-if="shouldDisplayCartBtn" @click="toggleCartConfirm()">
                        <img src="img/shopping-cart.png">
                    </div>

                    <div class="cart-btn-mobile" v-if="shouldDisplayCartBtnPreConf" @click="redirectToRecap()">
                        <img src="img/shopping-cart.png">
                    </div>
                </div>
            </div>
        </div>


        <!--    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <img :src="detailImg" alt="" class="img-fluid">
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>-->


        <div class="popup-valid confirm-popup" :class="{'show-dep-modal' : cartModalOpen}">
            <h4 class="beforeStarting">Attention</h4>
            <p>Si vous revenez à vos produits, la configuration en cours sera abandonnée</p>
            <div class="modal-footer">
                <button class="btn" @click="toggleCartConfirm()">Annuler</button>
                <button class="btn main" @click="deleteCurrentProdAndRedirect">Confirmer</button>
            </div>
        </div>

        <div class="header-backtosite-container">
            <a :href="siteInfos.UrlBoutique" v-if="isHome || isPreConf" class="btn back-btn">
                Retour vers le site
            </a>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'MainNav',
        data() {
            return {
                cartModalOpen: false
            }
        },
        computed: {


            detailImg() {
                return this.$store.state.detail_img
            },

            detailTitle() {
                return this.$store.state.detail_title
            },

            isViewerOpen() {
                return this.$store.state.isViewerOpen
            },
            siteInfos() {
                return this.$store.state.siteInfos;
            },
            apiUrl() {
                return this.$store.state.apiUrl
            },
            isHome() {
                return this.$route.name === "home";
            },
            isPreConf() {

                return this.$route.name === "preconstructor";
            },
            isRecap() {
                return parseInt(this.$route.params.step) === Object.keys(this.$store.state.steps).length
            },
            shouldDisplayCartBtn() {
                return (this.$store.state.products.filter(prod => !prod.deleted).length > 1 && (this.$store.state.hitOtherProd || this.$store.state.hitRecap) && !this.isRecap) && this.$route.name !== "preconstructor"
            },

            shouldDisplayCartBtnPreConf() {
                return (this.$store.state.products.filter(prod => !prod.deleted).length > 0 && this.$route.name === "preconstructor")
            }
        },
        watch: {},
        mounted() {
            this.$forceUpdate();
        },
        methods: {
            fillAndOpenDefaultModal() {
                let modal = $('#basicModal');
                modal.find('h5').text("");
                modal.find('img').attr('src', this.detailImg);
                modal.find('.extra-popup').html('')
                modal.modal('show');

            },
            redirectToHome() {
                if (confirm("Attention : en revenant sur la page d'accueil, vous perdrez tous les produits dans votre panier")) {
                    this.$router.push('/').catch();
                }
            },

            toggleCartConfirm() {
                this.cartModalOpen = !this.cartModalOpen

            },
            deleteCurrentProdAndRedirect() {
                this.$store.dispatch('deleteCurrentProdAndRedirect').then(() => {
                    this.toggleCartConfirm();
                    this.$forceUpdate();
                })
            },
            redirectToRecap() {
                this.$store.dispatch('redirectToRecap')
            }
        }
    }
</script>

<style>
    .header-backtosite-container {
        margin-right: 15px;
    }

    .ccm-trigger {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 10px;
        min-width: 100px;
        min-height: 48px;
        background: #747878;
        cursor: pointer;
        color: #ffffff;
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 2px;
    }

    .popup-valid.confirm-popup .modal-footer {
        display: flex;
        justify-content: space-around;
    }

    .popup-valid.confirm-popup .modal-footer {
        display: flex;
        justify-content: space-around;
        align-items: flex-end;
    }

    .popup-valid.confirm-popup .modal-footer .main {
    }

    .back-btn, .back-btn:hover {
        border: none;
        -webkit-box-shadow: none;
        box-shadow: none;
        cursor: pointer;
        padding: .75rem 1.25rem;
        color: #fff;
        z-index: 10;
        position: relative;
        outline: none;
        font-weight: bold;
    }

    .hide {
        display: none;
    }

    .recapRes {
        display: none;
    }

    nav {
        display: flex;
        height: 75px;
        z-index: 10;
        position: relative;
        align-items: center;
        justify-content: space-between;
    }

    @media screen and (max-width: 1200px) and (min-width: 575px) {
        nav {
            height: 55px;
        }
    }

    .fade.show {
        opacity: 1;
        background: rgba(0, 0, 0, 0.6);
    }

    .logo-container a {
        height: 100%;
        width: 100%;
        text-align: center;
        background: #201d1d;
        display: block;
    }

    .logo-container div img {
        height: 100%;
        width: auto;
        padding: 0;
        border-radius: 0px !important;
        display: block;
        max-height: 75px;
    }

    .logo-container:hover a img {
        padding: 0 !important;
    }

    .header-title {
        width: 50%;
        margin-bottom: 0;
        font-size: 1em;
        font-weight: bold;
        text-transform: uppercase;
        text-align: left;
        color: #ffffff;
        letter-spacing: unset;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .header-title-brand.hoverable {
        cursor: pointer;
    }

    .header-title-container {
        flex: 1;
        background: #aebebf;
        text-align: center;
        color: white;
    }

    .top-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        padding: 0 20px;
        background: #201d1d;
    }

    .header-tel-container {
        border: solid 2px #ffffff;
        border-radius: 25px;
        padding: 4px 10px;
    }

    .header-tel-container i {
        transform: rotateY(180deg);
    }

    .header-tel-container a,
    .header-tel-container a:hover,
    .header-tel-container a:focus {
        color: #ffffff;
        text-decoration: none;
        cursor: pointer;
    }

    .mobile-nav-bloc {
        display: none;
    }

    @media screen and (max-width: 1023px) {
        .top-info {
            width: 100%;
            max-height: 100%;
        }

        .top-info img {

            max-height: 50px;
        }

        .header-title {
            text-align: center;
            width: 100%;
            font-size: 0.9em;
            line-height: 12px;
            padding: 20px 0;
        }

        .header-title-container {
            display: none;
        }

        .header-tel-container {
            border: none; /*width: ;*/
        }

        .mobile-nav-bloc {
            align-items: center;
            justify-content: center;
            background-color: #201d1d;
            padding: 10px;
            display: flex;
        }

        .mobile-nav-viewer .rounded-icon {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }

        .mobile-nav-viewer {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }

        .mobile-nav-viewer span {
            color: #ffffff;
            font-size: 1.2rem;
        }

        nav {
            height: 65px;
        }

        .logo-container div img {
            max-height: 65px;
        }
    }

    @media screen and (max-width: 767px) {
        nav {
            height: 65px;
        }

        .mobile-nav-viewer {
            position: absolute;
            right: 50%;
            /* transform: translateX(-50%); */
        }

        .mobile-nav-bloc {
        }

        .header-title {
            display: none;
        }
    }

    .bold {
        font-weight: 700;
    }

    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 94%;
            margin: 1.875rem auto;
        }
    }

    @media (min-width: 1024px) {
        .modal-dialog {
            max-width: 80%;
            margin: 1.875rem auto;
        }
    }

    @media (max-width: 1024px) {
        .logo-container {
            width: auto;
            display: flex;
            justify-content: space-between;
        }

        .ccm-trigger {
            font-size: 12px;
        }
    }

    @media (min-width: 575px) {
        .ccm-trigger {
            display: none;
        }
    }

    .row {
        width: 100%;
    }
</style>
